import React from 'react'
import LoadingComponent from 'react-loading'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Loading = () => {
  return (
    <Wrapper>
      <LoadingComponent
        type='spin'
        color='gray'
        width='40px'
        height='40px'
      />
    </Wrapper>
  )
}

export default Loading
